import React, {
  forwardRef, useEffect, useState,
} from 'react';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { useCardsFilters } from '../useCardsFilters';
import { WILDCARD_SYMBOL } from '../utils';

function FioFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useTranslation();
  const [localValue, setLocalValue] = useState<string>('');
  const { filters, updateFilters, updateFiltersDebounced } = useCardsFilters();
  const [error, setError] = useState<string>();

  const onChangeHandler = (fio: string) => {
    setLocalValue(fio);
    if (fio.includes(WILDCARD_SYMBOL)) {
      setError(t('lunapoint:картотека.validation.invalid_characters', { value: WILDCARD_SYMBOL }) as unknown as string);
    } else {
      if (error) setError(undefined);
      updateFiltersDebounced({ 'user_data.fio__ilike': fio?.length > 0 ? fio : undefined });
    }
  };

  useEffect(() => {
    setLocalValue(filters['user_data.fio__ilike'] ?? '');
  }, [filters]);

  const reset = () => {
    updateFilters({ 'user_data.fio__ilike': undefined });
  };

  return (
    <PopoverWithButton
      {...props}
      onClickReset={reset}
      ref={ref}
      title={<div className="Body-2">{t('lunapoint:картотека.fio')}</div>}
    >
      <Control.Input
        errorMessage={error}
        hasError={!!error}
        isClearable
        onChangeValue={onChangeHandler}
        onClear={reset}
        value={localValue}
      />
    </PopoverWithButton>
  );
}

const FioFilterPopoverWithRef = forwardRef(FioFilterPopover);
export { FioFilterPopoverWithRef as FioFilterPopover };
